/**
 * @file src/i18n/languages.js
 * @description Registry of available languages with display metadata.
 *
 * Matches the 17 locales from the main marathon-photos-website.
 * Uses ISO 639-1 codes (with region for Chinese variants).
 */

const languages = [
  { code: 'en', title: 'English', flag: '🇳🇿', countryCode: 'nz' },
  { code: 'en-US', title: 'US English', flag: '🇺🇸', countryCode: 'us' },
  { code: 'fr', title: 'Français', flag: '🇫🇷', countryCode: 'fr' },
  { code: 'de', title: 'Deutsch', flag: '🇩🇪', countryCode: 'de' },
  { code: 'es', title: 'Español', flag: '🇪🇸', countryCode: 'es' },
  { code: 'it', title: 'Italiano', flag: '🇮🇹', countryCode: 'it' },
  { code: 'el', title: 'Ελληνικά', flag: '🇬🇷', countryCode: 'gr' },
  { code: 'nl', title: 'Nederlands', flag: '🇳🇱', countryCode: 'nl' },
  { code: 'pt', title: 'Português', flag: '🇵🇹', countryCode: 'pt' },
  { code: 'da', title: 'Dansk', flag: '🇩🇰', countryCode: 'dk' },
  { code: 'nb', title: 'Norsk', flag: '🇳🇴', countryCode: 'no' },
  { code: 'sv', title: 'Svenska', flag: '🇸🇪', countryCode: 'se' },
  { code: 'is', title: 'Íslenska', flag: '🇮🇸', countryCode: 'is' },
  { code: 'cs', title: 'Čeština', flag: '🇨🇿', countryCode: 'cz' },
  { code: 'ja', title: '日本語', flag: '🇯🇵', countryCode: 'jp' },
  { code: 'zh-CN', title: '简体中文', flag: '🇨🇳', countryCode: 'cn' },
  { code: 'zh-HK', title: '繁體中文', flag: '🇭🇰', countryCode: 'hk' },
  // { code: 'ar', title: 'العربية', flag: '🇸🇦', countryCode: 'sa' },
  // Arabic (ar-MSA) — awaiting professional translation
]

export default languages
